import { Theme } from '@mui/material'

const useStyles = {
  loginWaves: {
    width: '100%',
    height: '100%',
    position: 'fixed' as const,
    objectFit: 'cover' as const,
  },
  loginContainer: {
    height: '100vh',
    position: 'relative',
  },
  loginCard: {
    padding: '60px 40px',
    width: '550px',
  },
  logo: {
    display: 'block',
    margin: '0 auto',
    paddingBottom: '30px',
  },
  redirectLogo: {
    height: '38px',
  },
  loginBtn: {
    margin: '15px 0',
  },
  welcomeText: (theme: Theme) => ({ color: theme.palette.primary.main, textAlign: 'center', marginBottom: theme.spacing(4) }),
  divider: (theme: Theme) => ({ border: `1px solid #${theme.palette.grey[900]}14` }),
}
export default useStyles
